import { Box, Button } from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import DeleteIcon from '@mui/icons-material/Delete';
import { usePermissions } from '../../../../context/PermissionContext';

interface ReviewActionButtonsProps {
  onDisapprove: () => void;
  onApprove: () => void;
  onDelete: () => void;
  review:string
}

const ReviewActionButtons: React.FC<ReviewActionButtonsProps> = ({
  onDisapprove,
  onApprove,
  onDelete,
  review
}) => {
  const { hasPermission } = usePermissions();

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      {hasPermission(review, 'unblock') && (
        <Button
          variant="contained"
          color="success"
          startIcon={<ThumbUpIcon />}
          onClick={onApprove}
          size="small"
          sx={{ textTransform: 'none' }}
        >
          Approve
        </Button>
      )}
      {hasPermission(review, 'block') && (
        <Button
          variant="contained"
          color="warning"
          startIcon={<ThumbDownIcon />}
          onClick={onDisapprove}
          size="small"
          sx={{ textTransform: 'none' }}
        >
          Disapprove
        </Button>
      )}
      {hasPermission(review, 'Delete') && (
        <Button
          variant="outlined"
          color="error"
          startIcon={<DeleteIcon />}
          onClick={onDelete}
          size="small"
          sx={{ textTransform: 'none' }}
        >
          Delete
        </Button>
      )}
    </Box>
  );
};

export default ReviewActionButtons;
